<template>
  <div class="messages">
    <div class="header">
      <h3 class="title">Сообщения</h3>

      <toggle-button
        class="switch"
        :value="true"
        @change="onChangeEventHandler"
        :labels="{
          unchecked: 'все',
          checked: 'доска'
        }"
        :width="65"
      />
    </div>
    <CardChatMessages class="messages-event-container" :messages="messages" :showCardId="true" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { EDIT_CARD, SWITCH_SHOW_MESSAGES } from "@/store/actions.type";
import CardChatMessages from "./edit/card/CardChatMessages.vue";
import ToggleButton from "./general/ToggleButton.vue";

import cache from "@/store/cache.js";

export default {
  name: "Messages",
  components: { CardChatMessages, ToggleButton },
  computed: {
    ...mapGetters(["isMobileDevice"]),
    ...mapState("cardMessages", ["all"]),
    ...mapState("boards", { activeBoard: "active" }),
    messages() {
      if (this.onlyForActiveBoard && this.activeBoard) {
        return this.all.filter(e => {
          const card = cache.cards.byId(e.card_id);
          if (!card) return false;

          return this.activeBoard.id == card.board_id;
        });
      }
      return this.all;
    }
  },
  methods: {
    onChangeEventHandler({ value }) {
      this.onlyForActiveBoard = value;
    },
    hide() {
      this.$store.commit(SWITCH_SHOW_MESSAGES);
    },
    editCard(card_id) {
      this.$store.dispatch(EDIT_CARD, cache.cards.byId(card_id));
    }
  },
  data() {
    return {
      onlyForActiveBoard: true
    };
  }
};
</script>

<style lang="postcss" scoped>
.messages {
  display: grid;
  grid-template-areas:
    "header"
    "messages";
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  max-height: var(--messages-max-height);

  width: 350px;
  max-width: 350px;
  vertical-align: top;
  padding: 8px;
  background: var(--bg-list);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  color: var(--color-list);
  height: 100%;
  .header {
    position: relative;
    .title {
    }
    .switch {
      position: absolute;
      right: 0;
      top: 0;
      display: inline-block;
    }
  }
}

.messages-event-container {
  height: 100%;
  overflow-y: auto;
}

.title {
  margin: 0 0 10px;
  font-size: 14px;
  text-transform: uppercase;
  color: #999;
  padding: 5px;
  border-bottom: 1px dashed #ddd;
  text-overflow: ellipsis;
  user-select: none;
}
</style>
